import { createAction } from 'redux-actions';

export const setCurrentFirm = createAction('SET_CURRENT_FIRM', firm => ({ firm }));
export const setModalOpen = createAction('SET_MODAL_OPEN', isOpen => ({ isOpen }));

export const getFirms = createAction('GET_FIRMS');
export const getFirmsSuccess = createAction('GET_FIRMS_SUCCESS', firms => ({ firms }));
export const getFirmsFail = createAction('GET_FIRMS_FAIL', error => ({ error }));

export const getFirmsForLookup = createAction('GET_FIRMS_FOR_LOOKUP');
export const getFirmsForLookupSuccess = createAction('GET_FIRMS_FOR_LOOKUP_SUCCESS', firms => ({ firms }));
export const getFirmsForLookupFail = createAction('GET_FIRMS_FOR_LOOKUP_FAIL', error => ({ error }));

export const getFirmById = createAction('GET_FIRM_BY_ID', id => ({ id }));
export const getFirmByIdSuccess = createAction('GET_FIRM_BY_ID_SUCCESS', firm => ({ firm }));
export const getFirmByIdFail = createAction('GET_FIRM_BY_ID_FAIL', error => ({ error }));

export const updateFirm = createAction('UPDATE_FIRM', firm => ({ firm }));
export const updateFirmSuccess = createAction('UPDATE_FIRM_SUCCESS', firm => ({ firm }));
export const updateFirmFail = createAction('UPDATE_FIRM_FAIL', error => ({ error }));

export const addFirm = createAction('ADD_FIRM', firm => ({ firm }));
export const addFirmSuccess = createAction('ADD_FIRM_SUCCESS', firm => ({ firm }));
export const addFirmFail = createAction('ADD_FIRM_FAIL', error => ({ error }));

export const searchFirms = createAction('SEARCH_FIRM', query => ({ query }));
export const searchFirmsSuccess = createAction('SEARCH_FIRM_SUCCESS', firms => ({ firms }));
export const searchFirmsFail = createAction('SEARCH_FIRM_FAIL', error => ({ error }));

export const addFirmToOrganization = createAction('ADD_FIRM_TO_ORG', firmId => ({ firmId }));
export const addFirmToOrganizationSuccess = createAction('ADD_FIRM_TO_ORG_SUCCESS');
export const addFirmToOrganizationFail = createAction('ADD_FIRM_TO_ORG_FAIL');

export const removeFirmFromOrganization = createAction('REMOVE_FIRM_FROM_ORG', firmId => ({ firmId }));
export const removeFirmFromOrganizationSuccess = createAction('REMOVE_FIRM_FROM_ORG_SUCCESS');
export const removeFirmFromOrganizationFail = createAction('REMOVE_FIRM_FROM_ORG_FAIL');
